import script from "./propose-resolution-button.vue?vue&type=script&lang=js"
export * from "./propose-resolution-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__